/* Millionaire Strands – swipe + auto-rotate product slider (2 per view on phones, 4 on desktop) */
if (!customElements.get('ms-slider')) {
  customElements.define(
    'ms-slider',
    class MsSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ms-slider__track');
        this.dots = this.querySelector('.ms-slider__dots');
        this.slides = Array.from(this.track.children);
        this.page = 0;
        if (!this.slides.length) return;

        this.speed = (parseInt(this.dataset.speed, 10) || 4) * 1000;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reduceMotion;

        this.build();
        this.onResize = () => this.build();
        window.addEventListener('resize', this.onResize);

        let scrollTimer;
        this.track.addEventListener('scroll', () => {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(() => this.syncFromScroll(), 80);
        }, { passive: true });

        ['pointerdown', 'touchstart', 'focusin', 'mouseenter'].forEach((type) =>
          this.addEventListener(type, () => this.pause(), { passive: true })
        );
        ['mouseleave', 'focusout'].forEach((type) => this.addEventListener(type, () => this.resume()));
        this.addEventListener('touchend', () => this.resume(), { passive: true });

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        window.removeEventListener('resize', this.onResize);
      }

      perView() {
        return window.innerWidth >= 750 ? 4 : 2;
      }

      build() {
        const pages = Math.max(1, Math.ceil(this.slides.length / this.perView()));
        if (pages === this.pageCount) return this.goTo(Math.min(this.page, pages - 1), false);
        this.pageCount = pages;
        this.dots.innerHTML = '';
        this.dots.hidden = pages < 2;
        for (let i = 0; i < pages; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ms-slider__dot';
          dot.setAttribute('aria-label', `Slide ${i + 1} of ${pages}`);
          dot.addEventListener('click', () => {
            this.goTo(i, true);
            this.restart();
          });
          this.dots.appendChild(dot);
        }
        this.goTo(Math.min(this.page, pages - 1), false);
      }

      goTo(page, smooth) {
        this.page = (page + this.pageCount) % this.pageCount;
        const target = this.slides[this.page * this.perView()];
        if (target) {
          this.track.scrollTo({ left: target.offsetLeft - this.track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
        }
        this.paintDots();
      }

      syncFromScroll() {
        const width = this.track.clientWidth || 1;
        const page = Math.round(this.track.scrollLeft / width);
        this.page = Math.max(0, Math.min(page, this.pageCount - 1));
        if (this.track.scrollLeft + width >= this.track.scrollWidth - 2) this.page = this.pageCount - 1;
        this.paintDots();
      }

      paintDots() {
        Array.from(this.dots.children).forEach((dot, i) => {
          const active = i === this.page;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      start() {
        if (!this.autoplay || this.pageCount < 2 || this.timer) return;
        this.timer = setInterval(() => {
          if (document.hidden) return;
          if (document.querySelector('quick-add-modal[open]')) return;
          this.goTo(this.page + 1, true);
        }, this.speed);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      pause() {
        this.stop();
        clearTimeout(this.resumeTimer);
      }

      resume() {
        clearTimeout(this.resumeTimer);
        this.resumeTimer = setTimeout(() => this.start(), 4000);
      }

      restart() {
        this.stop();
        this.resume();
      }
    }
  );
}